export default __webpack_public_path__ + "excludedNoBorder.svg?ab6e3d9365912c77691440795680865a";